// extracted by mini-css-extract-plugin
module.exports = {"change":"style_change__1zrvr","logo":"style_logo__39bJr","welcome":"style_welcome__2Noev","form":"style_form__iglN7","footer":"style_footer__34gdH"};